import { render, staticRenderFns } from "./VantagensDetalhe.vue?vue&type=template&id=6bd49192&"
import script from "./VantagensDetalhe.vue?vue&type=script&lang=js&"
export * from "./VantagensDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./VantagensDetalhe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports